<template>
  <div>
    <!-- Header -->
    <div class="header bg-dark py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-4">
          <b-row class="justify-content-center">
            <b-col class="px-5">
              <h1 class="text-white">Inscrição</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-darker" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div class="text-center text-muted mb-4">
                    <small
                      >Escolha sua categoria de acordo com o regulamento.</small
                    >
                  </div>
                  <base-radio
                    name="agencia"
                    class="mb-3"
                    v-model="model.categoriaUsuario"
                  >
                    Peças Publicitárias
                    <a
                      href="/regulamentos/2026/regulamento-pecas-publicitarias-2026-2.pdf"
                      target="_blank"
                    >
                      <b-button class="ml-3" size="sm">Regulamento</b-button>
                    </a>
                  </base-radio>
                  <base-radio
                    name="estudante"
                    class="mb-3"
                    v-model="model.categoriaUsuario"
                  >
                    Novos Talentos (Estudantes)
                    <a
                      href="/regulamentos/2026/regulamento-novos-talentos-2026.pdf"
                      target="_blank"
                    >
                      <b-button class="ml-3" size="sm">Regulamento</b-button>
                    </a>
                  </base-radio>
                  <!--
                  <base-radio
                    name="profissional-independente"
                    class="mb-3"
                    v-model="model.categoriaUsuario"
                  >
                    Profissionais Independentes
                    <a
                      href="/regulamentos/2026/regulamento-pecas-publicitarias-2026-2.pdf"
                      target="_blank"
                    >
                      <b-button class="ml-3" size="sm">Regulamento</b-button>
                    </a>
                  </base-radio>
                   <base-radio
                    name="fornecedor"
                    class="mb-3"
                    v-model="model.categoriaUsuario"
                  >
                    Fornecedor
                    <a
                      href="/regulamentos/2023/regulamento-fornecedores-2023.pdf"
                      target="_blank"
                    >
                      <b-button class="ml-3" size="sm">Regulamento</b-button>
                    </a>
                  </base-radio> -->
                  <!-- <base-radio
                    name="profissional"
                    class="mb-3"
                    v-model="model.categoriaUsuario"
                  >
                    Profissional
                    <a
                      href="/regulamentos/regulamento-premio-profissionais-2021.pdf"
                      target="_blank"
                    >
                      <b-button class="ml-3" size="sm">Regulamento</b-button>
                    </a>
                  </base-radio> -->
                  <base-input
                    alternative
                    class="my-3"
                    prepend-icon="ni ni-email-83"
                    placeholder="E-mail"
                    name="E-mail"
                    :rules="{ required: true, email: true }"
                    v-model="model.email"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    placeholder="Senha"
                    type="password"
                    name="Senha"
                    :rules="{ required: true, min: 6 }"
                    v-model="model.password"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    placeholder="Confirmar Senha"
                    type="password"
                    name="Confirmar Senha"
                    :rules="{ is: model.password }"
                    v-model="model.confirmPassword"
                  >
                  </base-input>
                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4"
                      >Continuar</b-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "inicio",
  data() {
    return {
      model: {
        email: "",
        password: "",
        categoriaUsuario: "agencia",
      },
    };
  },
  methods: {
    onSubmit() {
      switch (this.model.categoriaUsuario) {
        case "agencia":
          this.$router.push({ name: "cadastroAgencia", params: this.model });
          break;
        case "estudante":
          this.$router.push({ name: "cadastroEstudante", params: this.model });
          break;
        case "profissional":
          this.$router.push({
            name: "cadastroProfissional",
            params: this.model,
          });
          break;
        case "fornecedor":
          this.$router.push({ name: "cadastroFornecedor", params: this.model });
          break;
        case "profissional-independente":
          this.$router.push({
            name: "cadastroProfissionalIndependente",
            params: this.model,
          });
          break;
      }
    },
  },
};
</script>
<style></style>
